'use client';

import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

import { AuthFormSlot } from '@/app/auth/components/auth-form-slot';
import { AuthLogo } from '@/app/auth/components/auth-logo';
import { cn } from '@/services/utils/classnames';

type AuthHeroSectionProps = {
  children: ReactNode;
  className?: string;
};

export const AuthHeroSection = ({
  children,
  className,
}: AuthHeroSectionProps) => {
  const pathname = usePathname();
  const isSignUpMode = pathname.includes('signup');

  return (
    <section
      className={cn(
        'relative',
        isSignUpMode ? 'h-[976px] dp-md:h-[760px]' : 'h-[632px]',
        className
      )}
    >
      <AuthLogo />
      <AuthFormSlot>{children}</AuthFormSlot>
    </section>
  );
};
